<template>
  <b-container class="my-5">
    <h2 class="text-center">{{ comment_title }}</h2>
    <b-row class="">
      <m-c15 v-if="comments.length > 0" :comments="comments"/>

      <div class="mt-3 ml-auto mr-auto" v-if="comments.length > 0">
        <m-pagination-400 :meta="meta" :on-change-page="changeCommentPage"/>
      </div>

      <div class="text-center col-lg-12" v-else>
        <h3 class="text-center">هیچ نظری یافت نشد.</h3>
      </div>

    </b-row>

  </b-container>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "Comment1",
  props: {
    commentable_id: {
      required: true
    },
    commentable_type: {
      required: true
    },
    comment_title:{
      default: 'نظرات'
    }
  },
  computed: {
    comments() {
      if (this.commentable_type == 'product') {
        return this.$store.getters["Comment/getProductComments"]
      }
      return this.$store.getters["Comment/getComments"]
    },
    ...mapGetters({
      meta: "Comment/getMeta",
    })
  },
  methods: {
    changeCommentPage(page) {
      let form = {id: this.commentable_id, comment_type: this.commentable_type}
      this.$store.dispatch("Comment/getClientComments", {form: form, page: page})
    },
  },
  mounted() {
    const form = {
      id: this.commentable_id,
      comment_type: this.commentable_type,
    }
    this.$store.dispatch("Comment/getClientComments", {form: form, page: 1})
  },
}
</script>

<style scoped>

</style>